/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    makeAsyncReducer,
    asyncDefaults,
    mergeReducers,
} from 'ui-lottery/src/utils/async_utils';
import { FETCH_LOCATIONS } from '../constants/actions';
import { RootState } from '../../dev/store';

export const PREFIX = `TREE_PERMIT_`;

const fetchLocations = makeAsyncReducer(FETCH_LOCATIONS);

export default mergeReducers(asyncDefaults([]), PREFIX, fetchLocations);

export const selectors = {
    getLocations: (state: RootState) => state.treePermit?.locations?.data,
};
